import { Box } from '@mui/system';
import { getBoundingBox, getCenter, Location, mapboxToken, mapStyle } from '../../../../utils/map';
import theme from '../../../../theme';

type StaticMapProps = {
  locations: Location[],
  markerColors?: any[],
  width?: number,
  height?: number
}

const defaultMarkerColor = theme.palette.primary.main

const StaticMap = ({
  locations,
  markerColors,
  width = 600,
  height = 400
}: StaticMapProps) => {
  const center: Location = getCenter(locations)

console.log('StaticMap locations:', locations);

  // Build marker string for Mapbox static API
  const markers = locations
    .map((location, index) => {
      const color = (markerColors && markerColors.length > index) 
        ? markerColors[index]?.replace('#', '') ?? defaultMarkerColor.replace('#', '')
        : defaultMarkerColor.replace('#', '')
      return `pin-s+${color}(${location.longitude},${location.latitude})`
    })
    .join(',')

  // URL encode the overlay (markers)
  const encodedMarkers = encodeURIComponent(markers)

  // Calculate bounds if multiple locations
  let positionPart = `${center.longitude},${center.latitude},9`

  if (locations.length > 1) {
    const boundingBox = getBoundingBox(locations, 2)
    // For auto bounds, use the format: [min_lon,min_lat,max_lon,max_lat]
    positionPart = `[${boundingBox[0].longitude},${boundingBox[0].latitude},${boundingBox[1].longitude},${boundingBox[1].latitude}]/auto`
  }

  // Build Mapbox static map URL
  const url = `https://api.mapbox.com/styles/v1/seerefine/${mapStyle}/static/${encodedMarkers}/${positionPart}/${width}x${height}@2x?access_token=${mapboxToken}`

  console.log('StaticMap URL:', url)

  return (
    <Box
      style={{
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <img 
        src={url}
        alt="Map" 
        style={{
          height: '100%',
          width: '100%',
          objectFit: 'cover'
        }}
        onError={(e) => console.error('Map image failed to load:', e)}
      />
    </Box>
  );
}

export default StaticMap
